import api from "../api";

const url = "/account";

export default {
  register(payload) {
    return api.post(`${url}/register/`, payload);
  },
  login(payload) {
    return api.post(`${url}/login/`, payload);
  },
  forget(payload) {
    return api.post(`${url}/forget/`, payload);
  },
  resetPassword(payload) {
    return api.post(`${url}/resetPassword/`, payload);
  },
  verify(payload) {
    return api.post(`${url}/activate/`, payload);
  },
  getProfile() {
    return api.get(`${url}/profile/`);
  },
  updateProfile(payload) {
    return api.patch(`${url}/profile/`, payload);
  },
  getAddresses(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/addresses/` + query);
  },
  getEndUserAddresses(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/end-user-addresses/` + query);
  },
  addAddress(payload) {
    return api.post(`${url}/addresses/`, payload);
  },
  addEndUserAddress(payload) {
    return api.post(`${url}/end-user-addresses/`, payload);
  },
  removeAddress(addressId) {
    return api.delete(`${url}/addresses/${addressId}/`);
  },
  removeEndUserAddress(addressId) {
    return api.delete(`${url}/end-user-addresses/${addressId}/`);
  },
  set_as_default(addressId) {
    return api.get(`${url}/addresses/${addressId}/set_default`);
  },
  set_as_default_end_user_address(addressId) {
    return api.get(`${url}/end-user-addresses/${addressId}/set_default`);
  },
  editAddress(addressId, payload) {
    return api.patch(`${url}/addresses/${addressId}/`, payload);
  },
  changePassword(payload) {
    return api.post(`${url}/changePassword/`, payload);
  },
  getClients(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/super-customers/clients/` + query);
  },
  getCostCenters(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/cost-centers` + query);
  },
  updateCostCenter(costCenterId, payload) {
    return api.patch(`${url}/cost-centers/${costCenterId}/`, payload);
  },
  createCostCenter(payload) {
    return api.post(`${url}/cost-centers/`, payload);
  },
  removeCostCenters(costCenterId) {
    return api.delete(`${url}/cost-centers/${costCenterId}/`);
  },
  setDefaultCostCenter(costCenterId, payload) {
    return api.patch(
      `${url}/cost-centers/${costCenterId}/set_default`,
      payload
    );
  },
  settings() {
    return api.get(`/settings/site-config/`);
  },
  getEmails(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/emails/` + query);
  },
  addEmail(payload) {
    return api.post(`${url}/emails/`, payload);
  },
  removeEmail(emailId) {
    return api.delete(`${url}/emails/${emailId}/`);
  },
  set_as_default_email(emailId) {
    return api.get(`${url}/emails/${emailId}/set_default`);
  },
  editEmail(emailId, payload) {
    return api.patch(`${url}/emails/${emailId}/`, payload);
  },
  setClientAsDefault(clientId, payload) {
    return api.post(
      `${url}/super-customers/clients/${clientId}/setDefault`,
      payload
    );
  },
  roles(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/super-customers/roles/` + query);
  },
  updateRoles(roleId, payload) {
    return api.patch(`${url}/super-customers/roles/${roleId}/`, payload);
  },
  createRoles(payload) {
    return api.post(`${url}/super-customers/roles/`, payload);
  },
  removeRoles(roleId) {
    return api.delete(`${url}/super-customers/roles/${roleId}/`);
  },
  getRole(roleId) {
    return api.get(`${url}/super-customers/roles/${roleId}/`);
  },
  getPermissions() {
    return api.get(`${url}/super-customers/permissions/`);
  },
  createClient(payload) {
    return api.post(`${url}/super-customers/clients/`, payload);
  },
  updateClient(clientId, payload) {
    return api.patch(`${url}/super-customers/clients/${clientId}/`, payload);
  },
  getClient(clientId) {
    return api.get(`${url}/super-customers/clients/${clientId}/`);
  },
  removeClient(clientId) {
    return api.delete(`${url}/super-customers/clients/${clientId}/`);
  },
  resetClientPassword(clientId, payload) {
    return api.patch(
      `${url}/super-customers/clients/${clientId}/setPassword`,
      payload
    );
  },
  changeAvatar(payload) {
    return api.post(`${url}/changeAvatar/`, payload, {
      mimeType: "multipart/form-data"
    });
  },
  updateInvoiceInfo(payload) {
    return api.put(`${url}/profile/update_invoice_info/`, payload);
  },
  updateSecurityQuestion(payload) {
    return api.put(`${url}/profile/update_security_question/`, payload);
  }
};
